import { Header } from "./Header";
import { Clock } from "./Clock";
import { useAuth } from "../../hooks/useAuth";
import { Login } from "../../pages/Login";

export function Layout({ children }) {
    const { isAuthenticated, checkedAuth } = useAuth();
    if (!checkedAuth) return <></>;
    if (!isAuthenticated) {
        return <Login />;
    }

    return (
        <div className="min-h-screen bg-gray-50">
            <Header />
            <main className="py-6 sm:h-[calc(100vh-56px)] sm:overflow-y-scroll">{children}</main>
            <Clock />
        </div>
    );
}
